import findEmailRoutes from './findEmail';
import verifyEmailRoutes from './verifyEmail';
export default [
  {
    path: '/bulk_route',
    name: 'BulkRoute',
    component: () => import('@/modules/uploadCSV/pages/BulkRoute.vue'),
    meta: {
      authRequired: true,
      pageTitle: 'Upload a CSV',
      breadcrumb: [
        {
          text: 'Upload A CSV',
          active: true,
        },
      ],
    },
  },
  ...findEmailRoutes,
  ...verifyEmailRoutes,
];
